import Vue from 'vue';
import Router from 'vue-router';
import login from '../components/login/login';
import contracts from '../components/contracts/contracts';
import alta from '../components/alta/alta';

Vue.use(Router)
var router = new Router({
  mode : 'history',
  routes: [
    {
        path: '/',
        redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      props:true
    },
    {
      path:'/contracts',
      name : 'contracts',
      component: contracts,
      props:true
    },
    {
      path:'/alta',
      name : 'alta',
      component: alta,
      props:true
    }
  ]
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js